/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined'
import PermIdentityOutlinedIcon from '@material-ui/icons/PermIdentityOutlined'
import FlagOutlinedIcon from '@material-ui/icons/FlagOutlined'
import FlagIcon from '@material-ui/icons/Flag'
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo'

export default [
  {
    pages: [
      {
        title: 'Analytics',
        href: '/admin-analytics',
        icon: AssessmentOutlinedIcon
      },
      {
        title: 'Pending Accounts',
        href: '/pending-accounts',
        icon: PermIdentityOutlinedIcon
      },
      {
        title: 'Pending Campaigns',
        href: '/pending-campaigns',
        icon: FlagOutlinedIcon
      },
      {
        title: 'Manage Accounts',
        href: '/manage-accounts',
        icon: SupervisorAccountIcon
      },
      {
        title: 'Manage Campaigns',
        href: '/manage-campaigns',
        icon: FlagIcon
      },
      {
        title: 'Manage Prices',
        href: '/manage-prices',
        icon: AttachMoneyIcon
      },
      {
        title: 'Active Videos',
        href: '/active-videos',
        icon: OndemandVideoIcon
      }
    ]
  }
]
